module.exports = __webpack_public_path__ + "static/media/Resume_2022.3ab65f08.png";